module.exports = __webpack_public_path__ + "3d135cd15109f9f668d1368b42d4dc4b.jpg";